export default "__VITE_ASSET__Bc4LCjMu__"